export default __webpack_public_path__ + "static/media/nft7.41b8bc87.png";